export function ConciergeHeader({
  title,
  advisorName,
  coachHandle,
}: {
  title: string;
  advisorName?: string | null;
  coachHandle?: string | null;
}) {
  return (
    <header className="text-center space-y-4 pt-4">
      <p className="concierge-eyebrow">Private Space</p>
      <h1 className="concierge-display text-5xl sm:text-6xl">
        {title}
      </h1>
      {advisorName && (
        <p className="text-muted-foreground italic text-lg">
          A quiet place to think out loud with{" "}
          <span className="not-italic text-foreground/90">{advisorName}</span>
          {coachHandle ? (
            <>
              {" "}· coached by{" "}
              <span className="not-italic text-foreground/90">{coachHandle}</span>
            </>
          ) : null}
          .
        </p>
      )}
    </header>
  );
}

export default ConciergeHeader;
